__turbopack_context__.v({
  "caption": "styles-module-scss-module__LX3aQW__caption",
  "captionCell": "styles-module-scss-module__LX3aQW__captionCell",
  "captionRow": "styles-module-scss-module__LX3aQW__captionRow",
  "cellInfo": "styles-module-scss-module__LX3aQW__cellInfo",
  "tableContainer": "styles-module-scss-module__LX3aQW__tableContainer",
});
